module.exports = __webpack_public_path__ + "static/media/admn-assistance.17a8782a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/admn-assistance.jpg
 ** module id = 769
 ** module chunks = 0
 **/